(() => {
  if (window.TemporiQuantityRules) return;
  const bounds = (rule, cartQuantity = 0) => {
    const step = Math.max(1, Number(rule.increment) || 1);
    const minimumTotal = Math.max(1, Number(rule.min) || 1);
    const cart = Math.max(0, Number(cartQuantity) || 0);
    const minimum = Math.ceil(Math.max(cart + 1, minimumTotal) / step) * step - cart;
    const maximum = rule.max === '' || rule.max == null ? null : Math.max(0, Math.floor(Number(rule.max) / step) * step - cart);
    return { minimum, maximum, step, cart, allowed: maximum == null || maximum >= minimum };
  };
  const ruleFor = input => ({ min: input.dataset.ruleMin, increment: input.dataset.ruleIncrement, max: input.dataset.ruleMax });
  const apply = (input, cartQuantity) => {
    const result = bounds(ruleFor(input), cartQuantity);
    input.dataset.cartQuantity = String(result.cart);
    input.min = result.minimum;
    input.step = result.step;
    if (result.maximum == null) input.removeAttribute('max'); else input.max = result.maximum;
    const message = document.querySelector('[data-quantity-rule-message="' + CSS.escape(input.id) + '"]');
    if (message) {
      message.hidden = !(Number(input.dataset.ruleMin) > 1 || Number(input.dataset.ruleIncrement) > 1 || result.maximum != null);
      message.textContent = result.allowed ? message.dataset.rules.replace('[min]', String(result.minimum)).replace('[step]', String(result.step)) + (result.maximum == null ? '' : ' ' + message.dataset.maximum.replace('[max]', String(result.maximum))) : message.dataset.blocked;
      message.textContent += ' ' + message.dataset.cart.replace('[count]', String(result.cart));
    }
    const container = input.form?.closest('[data-product-form-container]');
    if (container) {
      container.dataset.quantityBlocked = String(!result.allowed);
      if (input.form.getAttribute('aria-busy') !== 'true') {
        input.form.querySelectorAll('[name="add"]').forEach(button => {
          button.disabled = !result.allowed || container.dataset.variantAvailable !== 'true';
        });
      }
    }
    return result;
  };
  const valid = (quantity, rule, cartQuantity) => {
    const result = bounds(rule, cartQuantity);
    return result.allowed && Number.isInteger(quantity) && quantity >= result.minimum && (result.maximum == null || quantity <= result.maximum) && (quantity - result.minimum) % result.step === 0;
  };
  const applyCart = cart => document.querySelectorAll('[data-quantity-rule-input]').forEach(input => {
    const quantity = cart.items.filter(item => String(item.variant_id) === input.dataset.variantId).reduce((sum, item) => sum + Number(item.quantity), 0);
    apply(input, quantity);
  });
  window.TemporiQuantityRules = { bounds, valid, ruleFor, apply, applyCart };
  document.querySelectorAll('[data-quantity-rule-input]').forEach(input => apply(input, Number(input.dataset.cartQuantity)));
  ['product:variant-change', 'product:purchase-option-change', 'shopify:section:load'].forEach(event => document.addEventListener(event, () => document.querySelectorAll('[data-quantity-rule-input]').forEach(input => apply(input, Number(input.dataset.cartQuantity)))));
})();
